var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"band"},[_c('nb-radio',{staticClass:"band__options",attrs:{"options":_vm.options},model:{value:(_vm.selection),callback:function ($$v) {_vm.selection=$$v},expression:"selection"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }